module.exports = __webpack_public_path__ + "static/media/selfie-boy.88ff7456.png";